var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMenuBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-back-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75034 13.3667L3.35034 8.96666C3.28367 8.89999 3.23634 8.82777 3.20834 8.74999C3.18034 8.67221 3.16656 8.58888 3.167 8.49999C3.167 8.4111 3.181 8.32777 3.209 8.24999C3.237 8.17221 3.28411 8.09999 3.35034 8.03332L7.75034 3.63332C7.87256 3.5111 8.02545 3.44732 8.209 3.44199C8.39256 3.43666 8.55078 3.50043 8.68367 3.63332C8.817 3.75554 8.88656 3.90843 8.89234 4.09199C8.89811 4.27555 8.83411 4.43377 8.70034 4.56666L5.43367 7.83332H12.8837C13.0726 7.83332 13.231 7.89732 13.359 8.02532C13.487 8.15332 13.5508 8.31155 13.5503 8.49999C13.5503 8.68888 13.4866 8.84732 13.359 8.97532C13.2314 9.10332 13.073 9.1671 12.8837 9.16666H5.43367L8.70034 12.4333C8.82256 12.5555 8.88656 12.7111 8.89234 12.9C8.89811 13.0889 8.83411 13.2444 8.70034 13.3667C8.57811 13.5 8.42256 13.5667 8.23367 13.5667C8.04478 13.5667 7.88367 13.5 7.75034 13.3667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuBack);
export default __webpack_public_path__ + "static/media/arrow-menu-back.2a18b70741d5e5ceb85ad71700d02d40.svg";
export { ForwardRef as ReactComponent };